import React from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './login.module.scss';

const PasswordForm = ({
  handleInputChange,
  blurredFields,
  errors,
  handleLogin,
  handleInputBlurred,
  url,
  password,
  isDisabled
}) => (
  <form name="ForgotPasswordForm" className={styles.login_form} onSubmit={handleLogin} noValidate>
    <div className={styles.login_form_wrapper}>
    <div className={styles.welcome}>
       { url === '/auth/login' ? <FormattedMessage id="authentication.login.welcome" defaultMessage="Airport Portal" />
           : <FormattedMessage id="authentication.login.authentication" defaultMessage="Authentication" />
       }
    </div>
    <div className={styles.column_wrapper}>
      <div className={styles.form_column}>
        <label htmlFor="loginPassword">
          <div className={styles.form_control}>
          <input
            placeholder="Password"
            type="password"
            name="loginPassword"
            id="loginPassword"
            required
            value={password}
            onChange={(e) => { handleInputChange('password', e.target.value); }}
            onBlur={() => { handleInputBlurred('password'); }}
          />
          </div>
          { blurredFields.password && errors.passwordEmpty ? (
            <small className={styles.error}>
              <FormattedMessage id="authentication.login.error.password_empty" defaultMessage="This field cannot be empty" />
            </small>) : <small className={styles.empty_error} />
          }
        </label>
      </div>
    </div>
    {errors.invalidCredentials ? (
      <div className={`${styles.error} ${styles.invalid_credentials}`}>
        <FormattedMessage id="authentication.login.error.invalid_credentials" defaultMessage="Invalid Credentials" />
      </div>) : null}
      <div className={styles.button_wrapper}>
      <button
        type="submit"
        className={styles.button}
        disabled={isDisabled}
      >
        <FormattedMessage id="authentication.login.login" defaultMessage="Login" />
      </button>
      </div>
    </div>
  </form>
);


export default PasswordForm;
